"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ErrorModalDialog = _interopRequireDefault(require("../presentation/ErrorModalDialog"));
var _ServiceRegistry = _interopRequireDefault(require("../../../../util/ServiceRegistry"));
var _ErrorUtils = require("../../../../util/ErrorUtils");
var _class, _ErrorContainer;
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2020 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Top-level container for Error Container
 */
let ErrorContainer = exports.default = (0, _mobxReact.observer)(_class = (_ErrorContainer = class ErrorContainer extends _react.default.Component {
  clearError() {
    _ServiceRegistry.default.getService("AppStore").setAppError(null);
  }
  render() {
    const errorObject = _ServiceRegistry.default.getService("AppStore").appError;
    const errorMessage = (0, _ErrorUtils.getErrorMessage)(errorObject, _ServiceRegistry.default);
    const confirmLabel = errorObject.confirmLabel;
    return /*#__PURE__*/_react.default.createElement(_ErrorModalDialog.default, _extends({
      message: errorMessage,
      confirmLabel: confirmLabel,
      onConfirm: () => {
        if (errorObject.onConfirm) {
          errorObject.onConfirm();
        } else {
          this.clearError();
        }
      }
    }, this.props));
  }
}, _ErrorContainer.propTypes = {
  intl: _propTypes.default.objectOf(_propTypes.default.any).isRequired
}, _ErrorContainer)) || _class;